import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';
import CustomLink from 'components/Globals/Base/Link';

const calcNoOfCardsPerRow = (noOfCards: number, maxPerRow: number, isMobile = false): number => {
  if (noOfCards <= maxPerRow) return noOfCards;
  if (isMobile) {
    if (noOfCards % 3 === 0) return 3;
    if (noOfCards % 2 === 0) return 2;
  } else {
    if (noOfCards % 4 === 0) return 4;
    if (noOfCards % 3 === 0) return 3;
  }
  return maxPerRow;
};

export const PinnedSubsectionCardList = styled.div<{ theme: Theme; $noOfCards: number }>`
  display: grid;
  grid-template-columns: ${({ $noOfCards }) => `repeat(${calcNoOfCardsPerRow($noOfCards, 3, true)}, 1fr)`};
  gap: 16px;

  @media (${breakpoint.mdMin}) {
    grid-template-columns: ${({ $noOfCards }) => `repeat(${calcNoOfCardsPerRow($noOfCards, 5)}, 1fr)`};
  }

  @media (${breakpoint.lgMin}) {
    gap: 24px;
  }
`;

export const PinnedSubsectionCard = styled(CustomLink)<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${getColor('shadeBrandPrimary100')};
  padding: 16px 8px;
  border-radius: 8px;
  color: ${getColor('shadeBrandPrimary900')};
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: 0.5px;
  transition: background-color 0.2s ease-out;
  min-height: 100px;
  gap: 8px;
  padding: 16px 8px;

  & > img {
    max-width: 28px;
    min-width: 28px;
  }

  @media (${breakpoint.mdMin}) {
    padding: 16px;
  }

  @media (${breakpoint.lgMin}) {
    flex-direction: row;
    gap: 16px;
  }

  @media (${breakpoint.xlMin}) {
    font-size: 20px;

    & > img {
      max-width: 34px;
      min-width: 34px;
    }
  }

  // special styling for the loans and mortgages card
  .lm-label {
    @media (${breakpoint.lgMin}) {
      max-width: 78px;
    }
  }

  &:hover, &:focus {
    background-color: ${getColor('shadeBrandPrimary200')};
    color: ${getColor('shadeBrandPrimary900')};
  }
  &:focus {
    box-shadow: 0px 0px 7px 0px ${getColor('textLink')};
    outline: none;
  }  
  &:active {
    background-color: ${getColor('shadeBrandPrimary900')};
    color: ${getColor('textWhite')}; 
    & > img {
      filter: brightness(0) invert(1);
    }
  }
`;
